export const EMAIL_ALREADY_TAKEN_ERROR =
  "There's already an account with this email address.";
export const BAD_PASSWORD_ERROR_TOO_COMMON =
  'Avoid using commonly used passwords (ex: Password)';
export const BAD_PASSWORD_ERROR_TOO_SHORT = 'Must be at least 8 characters.';
export const PASSWORD_HELP_TEXT = 'Must be at least 8 characters';
export const PASSWORD_PLACEHOLDER = 'Password (must be 8 characters)';
export const EMAIL_INVALID_ERROR = 'Enter valid email address';
export const PASSWORD_REQUIRED_ERROR = 'Enter password';
export const SSO_ERROR_MESSAGE =
  'The account cannot be accessed because the login credentials could not be verified. Please try again or use a different account to sign up.';
export const MIN_PASSWORD_LENGTH = 8;
